module.exports = __webpack_public_path__ + "img/48_5.0905b12b.png";